import * as types from '../actions/types'
import createReducer from '../createReducer'

const initialCvListsState = {
  lastUpdatedLists: '',
  isFetchingLists: false,
  fetchListsSuccess: false,
  fetchListsFailure: false,
  fetchListsError: '',

  lists: {},
}

export default createReducer(initialCvListsState, {
  // LISTS
  [types.FETCH_LISTS_REQUEST](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingLists: true,
      fetchListsSuccess: false,
      fetchListsFailure: false,
      fetchListsError: '',
    })
    return newState
  },
  [types.FETCH_LISTS_SUCCESS](state, action) {
    let lists = {}
    for (let key of Object.keys(action.lists)) {
      lists[key] = action.lists[key]
    }

    const newState = Object.assign({}, state, {
      isFetchingLists: false,
      fetchListsSuccess: true,
      fetchListsFailure: false,
      fetchListsError: '',
      lastUpdatedLists: Date.now(),
      lists: lists,
    })
    return newState
  },
  [types.FETCH_LISTS_FAILURE](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingLists: false,
      fetchListsSuccess: false,
      fetchListsFailure: true,
      fetchListsError: action.error,
    })
    return newState
  },
})
